export default __webpack_public_path__ + "static/media/profile_icon.44d62acf.svg";